import React from 'react';
import { useTranslation } from 'react-i18next';
import { redirectToLogin } from '@redpanda/auth-utils';

const LoginPromptBanner: React.FC = () => {
  const { t } = useTranslation();
  const identityServiceUrl = process.env.REACT_APP_IDENTITY_SERVICE_URL || 'http://127.0.0.1:3000';

  return (
    <button
      onClick={() => redirectToLogin(identityServiceUrl, window.location.href)}
      className="flex-shrink-0 text-[var(--accent)] hover:underline text-sm font-medium whitespace-nowrap"
    >
      {t('auth.login_to_use_services')} →
    </button>
  );
};

export default LoginPromptBanner;
